import { createFileRoute } from '@tanstack/react-router';
import PersonalDataVerification from '@/features/account/profile/personal-data/verification';

export const Route = createFileRoute('/perfil/dados-pessoais/verificacao')({
  component: PersonalDataVerification,
  staticData: { subtitle: 'Verifique seu telefone' },
});
